import styled from 'styled-components';

export const Wrapper = styled.div`

img {
  max-width: 100%;
  max-height: 100%;
}
`